import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

const DateRangeContainer = styled.div`
  .native-date-range {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 10px;

    @media (max-width: ${screenSizes.tablet}) {
      flex-direction: column;
      gap: 10px;
    }
  }

  .date-input-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;

    label {
      font-size: 0.9rem;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.9);
      margin: 0;
    }
  }

  .native-date-input {
    background: rgba(255, 255, 255, 0.9);
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 12px;
    padding: 12px 16px;
    font-size: 1rem;
    color: #333;
    transition: all 0.3s ease;
    min-width: 160px;

    &:hover {
      border-color: rgba(255, 255, 255, 0.6);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    &:focus {
      outline: none;
      border-color: #fff;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
    }

    &::-webkit-calendar-picker-indicator {
      cursor: pointer;
      opacity: 0.7;

      &:hover {
        opacity: 1;
      }
    }
  }
`;

const DateRangePicker = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  startDateLabel = 'Fecha Inicio',
  endDateLabel = 'Fecha Fin',
  className = '',
}) => {
  const handleStartDateChange = (e) => {
    if (onStartDateChange) {
      onStartDateChange(e.target.value);
    }
  };

  const handleEndDateChange = (e) => {
    if (onEndDateChange) {
      onEndDateChange(e.target.value);
    }
  };

  return (
    <DateRangeContainer className={className}>
      <div className="native-date-range">
        <div className="date-input-group">
          <label>{startDateLabel}</label>
          <input
            type="date"
            value={startDate || ''}
            onChange={handleStartDateChange}
            className="native-date-input"
          />
        </div>
        <div className="date-input-group">
          <label>{endDateLabel}</label>
          <input
            type="date"
            value={endDate || ''}
            onChange={handleEndDateChange}
            className="native-date-input"
          />
        </div>
      </div>
    </DateRangeContainer>
  );
};

export default DateRangePicker;
